import React from "react";
import { useTranslation } from "react-i18next";
import { IBackButtonProps } from "./BackButtonInterfaces";
import { Typography } from "@mui/material";
import { useStyles } from "./BackButton.styles";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

export const BackButton = ({ handleClick, name, icon, disabled }: IBackButtonProps) => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <button
            type="button"
            disabled={disabled}
            onClick={handleClick}
            className={disabled ? classes.disabledButton : classes.button}
        >
            <Typography variant="h5">
                <span className={classes.backMessage}>
                    {icon === "cancel" ? (
                        <>
                            <CancelOutlinedIcon className={classes.icon} /> {t(name).toUpperCase()}
                        </>
                    ) : (
                        <>
                            <ArrowBackOutlinedIcon className={classes.icon} /> {t(name).toUpperCase()}
                        </>
                    )}
                </span>
            </Typography>
        </button>
    );
};
